import React, { FC, ReactElement } from 'react'
import styles from './CreateWalletWelcome.module.css'
import classNames from 'classnames'
import LogoIcon from '@/icons/logo-orb'

import CreateWalletHeader from '../create-wallet-header'
import CreateWalletFooter from '../create-wallet-footer'
import CreateWalletTitle from '../create-wallet-title'

import { useRouter } from 'next/navigation'

const CreateWalletWelcome: FC<{
	step: number
	totalSteps: number
	onNext: (evt: any) => void
	error: boolean
}> = ({ step, totalSteps, onNext, error }): ReactElement => {
	const router = useRouter()
	const handleRestoreWallet = React.useCallback(() => router.push('/restore-wallet'), [router])
	return (
		<>
			<CreateWalletHeader step={step} total={totalSteps} nextDisabled={error} onNext={onNext} />
			<div className={styles.root}>
				<LogoIcon className={styles.logo} />
				<CreateWalletTitle step={step} />
				{error && (
					<p className={classNames(styles.error, 'text-sm', 'regular')}>
						This browser is not supported
					</p>
				)}
			</div>
			<CreateWalletFooter
				step={step}
				nextDisabled={error}
				onNext={onNext}
				onBack={handleRestoreWallet}
			/>
		</>
	)
}

export default CreateWalletWelcome
